import { Button } from "@material-ui/core";
import { formatNameFromPersonObj } from "./utils";
import { withStyles } from "@material-ui/core/styles";
import IncidentLinkButton from "../Components/IncidentLinkButton";
import moment from "moment";

const StyledTableLinkButton = withStyles(() => ({
  root: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline",
    margin: "0",
    padding: "0",
    textTransform: "none",
  },
}))(Button);

// Type	Date & Time	Incident #	Officers	Role	Address
//The idNames need to match the row names in parse funtion
export const vehicleIncidentHistoryHeaders = [
  { title: "Incident\xa0#", idName: "incidentNumber", show: true },
  { title: "Type", idName: "type", show: true },
  { title: "Date & Time", idName: "callTime", show: true },
  { title: "Role", idName: "role", show: true },
  { title: "Operator", idName: "operator", show: true },
  { title: "Address", idName: "location", show: true },
];

// uses an array of personIncidentSpecifics
export function parseVehicleIncidentHistory(
  arr,
  clickHandler,
  userRoles,
  vehicleId
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((incident) => {
      const { id } = incident;
      const type = incident?.classification?.name;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const incidentNumber = (
        <IncidentLinkButton
          handleIncidentOpening={clickHandler}
          incident={incident}
          userRoles={userRoles}
        />
      );
      const vis = incident?.vehicleIncidentSpecifics.find(
        vis => vis?.vehicle?.id?.toString() === vehicleId.toString()
      );
      const role = vis && vis?.vehicleRole ? vis?.vehicleRole?.name : "";
      const operator =
        vis && vis?.operator ? formatNameFromPersonObj(vis?.operator) : "";
      const location = incident?.address?.name;
      tempRows.push(
        createIncidentData(
          type,
          callTime,
          incidentNumber,
          role,
          operator,
          location,
          id
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createIncidentData(
  type,
  callTime,
  incidentNumber,
  role,
  operator,
  location,
  id
) {
  return { type, callTime, incidentNumber, role, operator, location, id };
}

// ********************************************************************************************** //
export const vehicleTicketHistoryHeaders = [
  { title: "Incident\xa0#", idName: "incidentNumber", show: true },
  { title: "Ticket\xa0#", idName: "ticketNumber", show: true },
  { title: "Issued To", idName: "issuedTo", show: true },
  { title: "Viol", idName: "violation", show: true },
  { title: "Accident", idName: "accident", show: true },
];
// uses an array of personIncidentSpecifics
export function parseVehicleTicketHistory(
  arr,
  clickHandler,
  userRoles,
  handleTicketOpening
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((ticket) => {
      const { id } = ticket || {};
      const incidentNumber = (
        <IncidentLinkButton
          handleIncidentOpening={clickHandler}
          incident={ticket?.incident}
          userRoles={userRoles}
        />
      );
      // const ticketNumber = ticket?.ticketNumber //Make this a ticket number link
      const ticketNumber = (
        <StyledTableLinkButton
          data-cy={"tablecell-ticket-number-link-" + ticket?.id}
          onClick={() => {
            handleTicketOpening(ticket?.id, true);
          }}
        >
          {ticket?.ticketNumber || "Click to edit"}
        </StyledTableLinkButton>
      );
      const issuedTo = ticket?.issuedTo
        ? formatNameFromPersonObj(ticket?.issuedTo)
        : "";
      const violation = ticket?.ticketViolationPrototype?.fullName;
      const accident = ticket?.accident ? "true" : "false";

      tempRows.push(
        createTicketData(
          incidentNumber,
          ticketNumber,
          issuedTo,
          violation,
          accident,
          id
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createTicketData(
  incidentNumber,
  ticketNumber,
  issuedTo,
  violation,
  accident,
  id
) {
  return { incidentNumber, ticketNumber, issuedTo, violation, accident, id };
}
